'use strict';

(function ($window, openersClass, overlayClass, closeLinkClass, openClass, bodyOpen, lightboxActiveClass, lightboxInitialisation, lbMessageClass, getOpener, removeOnClick, onClick, getFirst, forEach, checkLoaded, postMessage, initialised) {
    var overlays = $window.document.getElementsByClassName(overlayClass);

    var currentYPosition = 0;
    var currentXPosition = 0;

    var openFunc = function openFunc(overlay, opener, lbMessage, closeLink) {
        currentYPosition = window.pageYOffset || document.documentElement.scrollTop;
        currentXPosition = window.pageXOffset || document.documentElement.scrollLeft;
        overlay.setAttribute('aria-hidden', false);

        if (opener) {
            opener.classList.add(openClass);
        } else {
            overlay.classList.add(openClass);
        }

        $window.document.body.classList.add(bodyOpen);
        var element = document.querySelector('.popup-open');
        element.style.top = '-' + currentYPosition + '.px';

        if (closeLink) {
            closeLink.focus();
        }

        if (lbMessage) {
            postMessage(lbMessage + '-opened', $window);
        }
    };

    var closeFunc = function closeFunc(overlay, opener, lbMessage) {
        overlay.classList.remove(lightboxActiveClass);
        overlay.setAttribute('aria-hidden', true);

        if (opener) {
            opener.classList.remove(openClass);
            opener.focus();
        } else {
            overlay.classList.remove(openClass);
        }

        $window.document.body.classList.remove(bodyOpen);

        if (lbMessage) {
            postMessage(lbMessage + '-closed', $window);
        }
        $window.scrollTo(currentXPosition, currentYPosition);
    };

    var backgroundClose = function backgroundClose($event, overlay, opener, lbMessage) {
        if ($event && $event.target && $event.target.classList.contains(overlayClass)) closeFunc(overlay, opener, lbMessage);
    };

    var init = function init() {
        var event = new CustomEvent('initialise-mutation-observer', {
            detail: {
                name: 'lightboxToggle',
                class: overlayClass,
                attribute: lbMessageClass
            }
        });
        $window.dispatchEvent(event);
        $window.addEventListener('queried-mutations', function ($event) {
            $window.dispatchEvent(new CustomEvent(lightboxInitialisation, {
                detail: $event.detail.lightboxToggle
            }));
        });

        initialised = true;
    };

    var overlaysFunc = function overlaysFunc(overlays) {
        if (!initialised) init();
        forEach(overlays, function (overlay) {
            var lbMessage = overlay.getAttribute(lbMessageClass);
            var opener = getOpener(overlay, openersClass, getFirst);
            var closeLink = getFirst(overlay.getElementsByClassName(closeLinkClass));
            var bgClose = function bgClose($event) {
                return backgroundClose($event, overlay, opener, lbMessage);
            };
            var mainClose = function mainClose() {
                return closeFunc(overlay, opener, lbMessage);
            };
            var mainOpen = function mainOpen() {
                return openFunc(overlay, opener, lbMessage, closeLink);
            };

            removeOnClick(overlay, bgClose);
            onClick(overlay, bgClose);

            if (typeof opener !== 'undefined') {
                removeOnClick(opener, mainOpen);
                onClick(opener, mainOpen);
            }

            removeOnClick(closeLink, mainClose);
            onClick(closeLink, mainClose);

            $window.addEventListener(lightboxInitialisation, function () {
                removeOnClick(closeLink, mainClose);
                removeOnClick(opener, mainOpen);
                removeOnClick(overlay, bgClose);
            });
        });
    };

    checkLoaded(overlays, overlaysFunc, $window, 100);

    $window.addEventListener(lightboxInitialisation, function ($event) {
        overlays = $event.detail && $event.detail.added && $event.detail.added.length > 0 ? $event.detail.added : $window.document.getElementsByClassName(overlayClass);
        overlaysFunc(overlays);
    });

    $window.addEventListener('message', function (message) {
        if (message.data === 'repaint') overlaysFunc(overlays);
    });
    $window.addEventListener('close-lightbox', function () {
        return forEach(overlays, function (overlay) {
            closeFunc(overlay, getOpener(overlay, openersClass, getFirst));
        });
    });

    $window.addEventListener('open-lightbox', function ($event) {
        if ($event && $event.detail && $event.detail.query) {
            var lbOverlay = document.querySelector($event.detail.query);

            if (lbOverlay) {
                var cl = lbOverlay.querySelector('.close-link');
                openFunc(lbOverlay, undefined, undefined, cl);
            }
        }
    });
})(window, 'lightb-opener', 'lightb-overlay', 'close-link', 'open', 'popup-open', 'lightb-active', 'initialise-lightbox-toggle', 'lb-message', function ($element, sibilingClass, getFirst) {
    var sibling = $element.previousSiblingElement;

    if (sibling && sibling.classList.contains(sibilingClass)) return sibling;else return getFirst($element.parentElement.getElementsByClassName(sibilingClass));
}, function ($element, func) {
    return $element ? $element.removeEventListener('click', func) : null;
}, function ($element, func) {
    return $element ? $element.addEventListener('click', func) : null;
}, function (arr) {
    return arr[0];
}, function (arr, func) {
    return Array.prototype.forEach.call(arr, func);
}, function ($elements, $function, $win, iterationMax) {
    if ($elements === undefined) return;

    (function checkIfLoaded($elements, $function, $win, iterationMax, iterationCount) {
        if (iterationCount < iterationMax) {
            if ($elements.length > 0) $function($elements);else $win.requestAnimationFrame(function () {
                return checkIfLoaded($elements, $function, $win, iterationMax, iterationCount + 1);
            });
        } else console.debug('Why is the lightbox toggle being run when there are no lightboxes?');
    })($elements, $function, $win, iterationMax, 0);
}, function (message, $window) {
    $window.postMessage(message, $window.location.protocol + '//' + $window.location.host);
}, false);